import { render, staticRenderFns } from "./bind-process.vue?vue&type=template&id=ae3917f2&scoped=true"
import script from "./bind-process.ts?vue&type=script&lang=ts&external"
export * from "./bind-process.ts?vue&type=script&lang=ts&external"
import style0 from "./bind-process.scoped.scss?vue&type=style&index=0&id=ae3917f2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3917f2",
  null
  
)

export default component.exports